const API_URL = import.meta.env.VITE_API_URL as string;

interface EditorialImageProps {
  src?: string | null;
  seed: string;
  alt: string;
  aspect?: string;
  duotone?: boolean;
  flat?: boolean;
  className?: string;
  priority?: boolean;
  size?: 'thumb' | 'card' | 'large' | 'hero';
}

const SIZE_DIMENSIONS: Record<NonNullable<EditorialImageProps['size']>, [number, number]> = {
  thumb: [320, 400],
  card: [700, 875],
  large: [1200, 1500],
  hero: [2000, 1400],
};

export function placeholderImage(seed: string, width = 700, height = 875) {
  return `https://picsum.photos/seed/${encodeURIComponent(seed)}/${width}/${height}`;
}

function buildSrc(path: string | null | undefined, width: number, height: number, seed: string): string {
  if (!path) return placeholderImage(seed, width, height);
  if (path.startsWith('http')) return path;
  return `${API_URL}${path}`;
}

export function EditorialImage({
  src,
  seed,
  alt,
  aspect = 'aspect-[4/5]',
  duotone = true,
  flat = false,
  className = '',
  priority = false,
  size = 'card',
}: EditorialImageProps) {
  const [width, height] = SIZE_DIMENSIONS[size];
  const resolvedSrc = buildSrc(src, width, height, seed);

  return (
    <div
      className={`${duotone ? `duotone ${flat ? 'duotone-flat' : ''}` : ''} ${aspect} overflow-hidden ${className}`}
    >
      <img
        src={resolvedSrc}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding={priority ? 'sync' : 'async'}
        className="h-full w-full object-contain"
      />
    </div>
  );
}
